<button
  type="button"
  class="cb-fab"
  aria-label="Open HRMS Assistant"
  *ngIf="!isOpen"
  (click)="toggleChat()"
>
  <span class="cb-fab-ring"></span>
  <span class="cb-fab-icon">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M3 5V20.793C3 21.238 3.539 21.461 3.854 21.146L7.707 17.293C7.895 17.105 8.149 17 8.414 17H19C20.105 17 21 16.105 21 15V5C21 3.895 20.105 3 19 3H5C3.895 3 3 3.895 3 5Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="8.5" cy="10.5" r="1" fill="#fff"/>
      <circle cx="12" cy="10.5" r="1" fill="#fff"/>
      <circle cx="15.5" cy="10.5" r="1" fill="#fff"/>
    </svg>
  </span>
  <span class="cb-fab-badge" *ngIf="unreadCount > 0">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
</button>

<section class="cb-panel" *ngIf="isOpen" aria-label="HRMS Assistant">

  <header class="cb-header">
    <div class="cb-header-avatar">
      <span>HR</span>
      <span class="cb-online-dot"></span>
    </div>
    <div class="cb-header-info">
      <span class="cb-header-name">{{ isHrRole ? 'HR Assistant' : 'HRMS Assistant' }}</span>
      <span class="cb-header-status" [class.hr-mode]="isHrRole">
        <span class="cb-status-dot"></span>
        {{ isHrRole ? 'HR & Admin Mode' : 'Online · Always ready' }}
      </span>
    </div>
    <button type="button" class="cb-close" aria-label="Close chat" (click)="closeChat()">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M4 4L14 14M14 4L4 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </header>

  <div class="cb-quick-grid" *ngIf="messages.length <= 1">
    <button
      type="button"
      class="cb-quick-tile"
      *ngFor="let action of quickActions"
      (click)="runQuickAction(action)"
    >
      <span class="cb-quick-icon" [innerHTML]="action.svg"></span>
      <span class="cb-quick-label">{{ action.label }}</span>
    </button>
  </div>

  <div class="cb-messages" #messagesContainer>
    <ng-container *ngFor="let message of messages; let i = index">

      <div class="cb-row cb-row--bot" *ngIf="message.sender === 'bot'">
        <div class="cb-avatar cb-avatar--bot">HR</div>
        <div class="cb-msg-col">
          <div class="cb-bubble cb-bubble--bot">
            <span class="cb-bubble-text" *ngIf="message.text">{{ message.text }}</span>

            <div class="cb-cards" *ngIf="message.type === 'cards' && message.cards?.length">
              <div
                class="cb-card"
                *ngFor="let card of message.cards"
                [class.cb-card--highlight]="card.highlight"
              >
                <span class="cb-card-label">{{ card.label }}</span>
                <span class="cb-card-value">{{ card.value }}</span>
                <span class="cb-card-sub" *ngIf="card.sub">{{ card.sub }}</span>
              </div>
            </div>

            <a
              *ngIf="message.route"
              class="cb-link"
              [routerLink]="message.route"
              [queryParams]="message.queryParams || null"
              (click)="closeChat()"
            >
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5h9M7 2.5l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              {{ message.linkText || 'Open page' }}
            </a>
          </div>

          <span class="cb-time" *ngIf="message.timestamp">{{ message.timestamp | date:'h:mm a' }}</span>

          <div class="cb-chips" *ngIf="message.suggestedActions?.length">
            <button
              type="button"
              class="cb-chip"
              *ngFor="let action of message.suggestedActions"
              (click)="runSuggestedAction(action)"
            >{{ action }}</button>
          </div>
        </div>
      </div>

      <div class="cb-row cb-row--user" *ngIf="message.sender === 'user'">
        <div class="cb-msg-col cb-msg-col--user">
          <div class="cb-bubble cb-bubble--user">
            <span class="cb-bubble-text">{{ message.text }}</span>
          </div>
          <div class="cb-user-meta">
            <span class="cb-time cb-time--user" *ngIf="message.timestamp">{{ message.timestamp | date:'h:mm a' }}</span>
            <span class="cb-tick">
              <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                <path d="M1 5l3.5 3.5L13 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="cb-avatar cb-avatar--user">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="5.5" r="2.5" fill="currentColor"/>
            <path d="M2.5 13c0-3.038 2.462-5.5 5.5-5.5s5.5 2.462 5.5 5.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          </svg>
        </div>
      </div>

    </ng-container>

    <div class="cb-row cb-row--bot" *ngIf="isSending">
      <div class="cb-avatar cb-avatar--bot">HR</div>
      <div class="cb-bubble cb-bubble--bot cb-bubble--typing">
        <span class="cb-dot"></span>
        <span class="cb-dot"></span>
        <span class="cb-dot"></span>
      </div>
    </div>
  </div>

  <div class="cb-topics-drawer" *ngIf="topicsOpen">
    <div class="cb-topics-header">
      <span>{{ isHrRole ? 'HR Topics' : 'What can I help with?' }}</span>
      <button type="button" class="cb-topics-close" (click)="topicsOpen = false">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>
    <div class="cb-topics-list">
      <button
        type="button"
        class="cb-topic-item"
        *ngFor="let t of currentTopics"
        (click)="sendTopicMessage(t.message)"
      >
        <span class="cb-topic-icon" [innerHTML]="t.svg"></span>
        <div class="cb-topic-text">
          <span class="cb-topic-label">{{ t.label }}</span>
          <span class="cb-topic-desc">{{ t.desc }}</span>
        </div>
        <svg class="cb-topic-arrow" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8M8 4l3 3-3 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>
  </div>

  <form class="cb-input-bar" (ngSubmit)="sendMessage()">
    <button
      type="button"
      class="cb-menu-btn"
      [class.cb-menu-btn--active]="topicsOpen"
      (click)="topicsOpen = !topicsOpen"
      aria-label="Browse topics"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <line x1="2" y1="4.5" x2="16" y2="4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <line x1="2" y1="9"   x2="16" y2="9"   stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <line x1="2" y1="13.5" x2="10" y2="13.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </button>
    <input
      #chatInput
      type="text"
      name="chatMessage"
      [(ngModel)]="currentMessage"
      [disabled]="isSending"
      autocomplete="off"
      placeholder="Ask me anything…"
      class="cb-input"
    />
    <button type="submit" class="cb-send" [disabled]="!currentMessage.trim() || isSending" aria-label="Send">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M17.5 2.5L9.167 10.833M17.5 2.5L12.5 17.5l-3.333-6.667L2.5 7.5l15-5z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </form>

  <div class="cb-footer-hint">Press <kbd>Esc</kbd> to close</div>

</section>
